import { com } from '@eidu/web'
import { requireResourceText } from '../../resource/client'
import EntitySnapshot = com.eidu.entity.publish.EntitySnapshot

const fetchVersionSnapshot = async (snapshotResourceKey: string): Promise<EntitySnapshot> =>
  EntitySnapshot.fromJsonString(await requireResourceText(snapshotResourceKey))

export default fetchVersionSnapshot
